// Generated by scripts/build-ui-icons.mjs.
export { BellRinging as default } from "../ui/glyphs-1";
